
const REGULATION_CODE_TYPES = {
    COM: 0,
    ITALY: 1,
    SPAIN: 2,
    NEVADA: 3,
    GIB: 4,
    DELAWARE: 6,
    NJ: 7,
    DK: 8,
    ROMANIA: 9,
    GERMANY: 12,
    PORTUGAL: 14,
    SWEDEN: 15,
    MALTA: 16,
    SH: 18,
    MICHIGAN: 19,
    CANADA_ONTARIO: 21,
    NETHERLANDS: 22,
    UK: 255
};


const REGULATION_NAMES = {
    [REGULATION_CODE_TYPES.ITALY]: 'Italy',
    [REGULATION_CODE_TYPES.SPAIN]: 'Spain',
    [REGULATION_CODE_TYPES.NEVADA]: 'Nevada',
    [REGULATION_CODE_TYPES.GIB]: 'Gibraltar',
    [REGULATION_CODE_TYPES.DELAWARE]: 'Delaware',
    [REGULATION_CODE_TYPES.NJ]: 'NewJersey',
    [REGULATION_CODE_TYPES.DK]: 'Denmark',
    [REGULATION_CODE_TYPES.PORTUGAL]: 'Portugal',
    [REGULATION_CODE_TYPES.SWEDEN]: 'Sweden',
    [REGULATION_CODE_TYPES.UK]: 'UK',
    [REGULATION_CODE_TYPES.MALTA]: 'Malta',
    [REGULATION_CODE_TYPES.ROMANIA]: 'Romania',
    [REGULATION_CODE_TYPES.GERMANY]: 'Germany',
    [REGULATION_CODE_TYPES.CANADA_ONTARIO]: 'Ontario',
    [REGULATION_CODE_TYPES.NETHERLANDS]: 'Netherlands',
    [REGULATION_CODE_TYPES.MICHIGAN]: 'Michigan'
};


const REGULATION_SUFFIX = {
    [REGULATION_CODE_TYPES.COM]: 'com',
    [REGULATION_CODE_TYPES.ITALY]: 'it',
    [REGULATION_CODE_TYPES.SPAIN]: 'es',
    [REGULATION_CODE_TYPES.NEVADA]: 'nev',
    [REGULATION_CODE_TYPES.GIB]: 'gib',
    [REGULATION_CODE_TYPES.DELAWARE]: 'del',
    [REGULATION_CODE_TYPES.NJ]: 'nj',
    [REGULATION_CODE_TYPES.DK]: 'dk',
    [REGULATION_CODE_TYPES.PORTUGAL]: 'pt',
    [REGULATION_CODE_TYPES.SWEDEN]: 'sw',
    [REGULATION_CODE_TYPES.UK]: 'uk',
    [REGULATION_CODE_TYPES.MALTA]: 'mt',
    [REGULATION_CODE_TYPES.ROMANIA]: 'ro',
    [REGULATION_CODE_TYPES.CANADA_ONTARIO]: 'ont',
    [REGULATION_CODE_TYPES.NETHERLANDS]: 'nl',
    [REGULATION_CODE_TYPES.MICHIGAN]: 'mi'
};

const REGULATION_STATUS_ID_MAP = {
    APPROVED_FOR_REGULATION: 0,
    PENDING_VERIFICATION : 1,
    PENDING_DOCUMENTS: 2
};

const BRANDS = {
    COM : 0,
    NJ888 : 73,
    SPAIN: 58,
    CANADA: 87,
    MICHIGAN: 91,
    MRGREEN_SE: 92,
    MRGREEN_GER: 93,
    MRGREEN_DK: 94,
};


export {REGULATION_CODE_TYPES, REGULATION_NAMES, REGULATION_SUFFIX, BRANDS, REGULATION_STATUS_ID_MAP};
